import { privateApi } from 'services/Api/ApiService';
import { LinkedinCredentialsItem } from './types';

export const FIXED_LINKEDIN_CREDENTIALS_ITEM_ID = 'GLOBAL';

const fetchLinkedinCredentials = async (): Promise<LinkedinCredentialsItem[]> =>
    privateApi.get<LinkedinCredentialsItem[]>(`admin/linkedin-credentials`);

const reauthenticateLinkedinCredentialsItem = async (
    id: string,
    code: string,
    redirectUri: string,
): Promise<LinkedinCredentialsItem> =>
    privateApi.put<LinkedinCredentialsItem>(`admin/linkedin-credentials/${id}`, {
        code,
        redirectUri,
    });

export const LinkedinCredentialsGateway = {
    fetchLinkedinCredentials,
    reauthenticateLinkedinCredentialsItem,
};
